import React from 'react';
import { InputAdornment, TextField } from '@mui/material';

import FormControlSizeOverrides from './FormControlSizeOverrides';
import FormFieldHelperAction, { IHelperAction } from './FormFieldHelperAction';

interface FormComponentProps {
  adornmentText?: string;
  inputProps?: any;
  disabled?: boolean;
  error: any;
  helperAction?: IHelperAction;
  helperText?: string;
  label?: string;
  multiline?: boolean;
  name: string;
  onBlur?: any;
  onChange?: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement | Element
  >;
  placeholder: string;
  readonly?: boolean;
  required?: boolean;
  size?: FormControlSizeOverrides;
  type?: string;
  value?: any;
}

const FormComponent: React.FC<FormComponentProps> = (props) => {
  const {
    adornmentText,
    inputProps,
    disabled = false,
    error,
    helperAction,
    helperText,
    label,
    multiline = false,
    name,
    onBlur,
    onChange,
    placeholder,
    readonly = false,
    required = false,
    size,
    type,
    value,
  } = props;

  return (
    <>
      <TextField
        name={name}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        InputProps={{
          readOnly: readonly,
          ...(adornmentText && {
            endAdornment: (
              <InputAdornment position="end">{adornmentText}</InputAdornment>
            ),
          }),
        }}
        disabled={disabled}
        error={error}
        fullWidth
        helperText={helperText}
        inputProps={{
          'data-testid': name,
          readOnly: readonly,
          ...inputProps,
        }}
        label={label ? `${label}${required ? '*' : ''}` : undefined}
        multiline={multiline}
        placeholder={placeholder}
        rows={3}
        size={size || 'small'}
        type={type}
      />
      <FormFieldHelperAction action={helperAction} />
    </>
  );
};

export default FormComponent;
